import { PlayerItem, PlayerItemGrouping } from '../../communication/player-account/PlayerAccountApi'
import {  PlayerItemAction, PlayerItemActionsTypes } from './PlayerItemsActions'

export interface PlayerItemsState {
    playerItems: PlayerItem[];
    playerItemGroupings: PlayerItemGrouping[]
    error: Error;
}

const initialState: PlayerItemsState = {
	playerItems: [],
	playerItemGroupings: [],
	error: null,
}

export const playerItemsReducer = (
	state: PlayerItemsState = initialState,
	action: PlayerItemAction,
): PlayerItemsState => {
	switch (action.type) {
	case PlayerItemActionsTypes.GET_PLAYER_ITEMS_STARTED:
		return { ...state }
	case PlayerItemActionsTypes.GET_PLAYER_ITEMS_SUCCESS:
		return { ...state, playerItems: action.payload.playerItems }
	case PlayerItemActionsTypes.GET_PLAYER_ITEMS_FAILURE:
		return { ...state, error: action.payload.error }
	case PlayerItemActionsTypes.GET_PLAYER_ITEM_GROUPINGS_STARTED:
		return { ...state }
	case PlayerItemActionsTypes.GET_PLAYER_ITEM_GROUPINGS_SUCCESS:
		return { ...state, playerItemGroupings: action.payload.playerItemGroupings }
	case PlayerItemActionsTypes.GET_PLAYER_ITEM_GROUPINGS_FAILURE:
		return { ...state, error: action.payload.error }            
	default:
		return state
	}
}
